import React from 'react';
import { Text, View, Flex, Button, useTheme } from '@aws-amplify/ui-react';
import { useTokens } from '../components/AuthPage'; // AuthPageからuseTokensをインポート
import IcoTutorial from '../image/ico_tutorial_banner.png';
import { IoMdClose } from "react-icons/io";

type TutrialBannerProps = {
  setIsLoadedHeader: (flag:boolean) => void;
  reloadFlag?: boolean;
};

export default function TutorialBanner(props: TutrialBannerProps) {
  const {tokens} = useTheme();
  
  const { getTokens, auth } = useTokens(); // useTokensフックを使用
  const [tokenInfo, setTokenInfo] = React.useState<any>(null);

  // エラーメッセージ
  const ERROR_MESSAGE_PROCESSING_ERROR = "処理中にエラーが発生しました。もう一度お試し下さい。";
  // アカウントステータス
  const [isFirstLogin, setIsFirstLogin] = React.useState(false);

  // ステータスのチェック
  const callCheckFirstLogin = async (token:string | null, decodedAccessTokenInfo:any | null) => {
    const baseUrl:string = process.env.REACT_APP_API_BASE_URL || '';
    const path:string = '/common/managefirstlogin';
    let errorMessage = '';
    try {
      const response = await fetch(baseUrl.concat(path),{
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`, //アクセストークン
          'Content-Type': 'application/json;'
        },
      });
      if (response.ok) {
        const result = await response.json();
        if ('isfirstlogin' in result) {
          if (result.isfirstlogin) {
            setIsFirstLogin(result.isfirstlogin);
          } else {
            setIsFirstLogin(false);
          }
        } else {
          const result = {hasError:true};
          return result;
        }
      } else {
        throw new Error(`HTTP error! status: ${response.status}`);
      } 
    } catch (error) {
      console.error(error);
      const result = {hasError:true};
      return result;
    }
  };

  React.useEffect(() => {
    const handleLoad = async () => {
      // 最新のアクセストークンを取得する
      const {decodedAccessTokenInfo, idToken} = await getTokens();
      setTokenInfo(decodedAccessTokenInfo);

      // アクセストークンのconsole
      console.log("Decoded Access Token Info:", decodedAccessTokenInfo);

      // ステータスのチェック
      const callCheckAccountStatusResult = await callCheckFirstLogin(idToken, decodedAccessTokenInfo);
      if (callCheckAccountStatusResult && 'hasError' in callCheckAccountStatusResult) {
        alert("処理中にエラーが発生しました。画面を再読み込みしてください。");
        return;
      }
    }
    if (props.reloadFlag === undefined || !props.reloadFlag) {
      handleLoad();
    }
  },[props.reloadFlag]);

  const handleOpenTutorial = () => {
    // https://cnavi.g-search.or.jp/useful/technique/index.html
    window.open(`${process.env.REACT_APP_OPENSITE_BASE_URL}/useful/technique/index.html`, "_blank", "noreferrer");
  };

  return (
    <Flex width="310px" backgroundColor="white" direction="column" alignItems="center" padding="10px" position="fixed" right="10px" bottom="10px" border="1px solid black" style={{ zIndex: "20" }} display={isFirstLogin ? "flex" : "none"} gap="5px">
      <Flex width="100%" backgroundColor="gold" color="black" alignItems="center" justifyContent="center" position="relative" padding="5px">
        <Text fontSize={tokens.fontSizes.xxxl}>
          はじめての方へ
        </Text>
        <Button onClick={() => setIsFirstLogin(false)} position="absolute" top="0" right="0" transform="translate(50%, -50%)" backgroundColor="#f0f0f0" border="none" aria-label="閉じる" padding="0" width="32px" height="32px" borderRadius="50%" display="flex" alignItems="center" justifyContent="center">
          <IoMdClose size={20} color="black" />
        </Button>
      </Flex>
      <img src={IcoTutorial} width="35%" />
      <Button width="100%" border="none" borderRadius="0" backgroundColor={tokens.colors.blue[60]} color="white" fontSize={tokens.fontSizes.xl} fontWeight="normal" textAlign="center" padding="10px 3px" onClick={handleOpenTutorial} >
        欲しいリストは <View as="span" fontWeight={tokens.fontWeights.bold}>❝ 3ステップ ❞</View> で絞り込み
      </Button>
    </Flex>
  );
};